// extracted by mini-css-extract-plugin
module.exports = {"signupBtnContainer":"SignUpButton_signupBtnContainer__HPApj","left":"SignUpButton_left__VUjtM","center":"SignUpButton_center__22epk","right":"SignUpButton_right__WpXqd"};